import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-BLACK_1 lg:relative lg:z-20">
      <div className="grid justify-around gap-y-6 py-10 text-center text-sm text-WHITE_1 md:pb-12 md:pt-20">
        <Link href="/about">About</Link>
        <Link href="/terms">利用規約</Link>
        <Link href="/privacyPolicy">プライバシーポリシー</Link>
        <Link href="/contacts">ご意見／お問い合わせ</Link>
        <Link href="/management">サイト運営</Link>
      </div>
      <p className="w-full pb-5 text-center text-sm text-WHITE_2">
        Copyright © scenalys. All Rights Reserved
      </p>
    </footer>
  );
}
